export const OCCUPANCY_TYPES = {
  DOMESTIC: 'domestic',
  INTERNATIONAL: 'international'
};

export const GENDER_RESTRICTIONS_TO_GENDER_TYPE = { MALES: 'F', FEMALES: 'M' };
